import WBox from './WBox';
export default WBox;
